<template>
    <v-card flat :color="color">
        <v-card-text>

            <!-- THANK YOU TEXT -->
            <div v-if="readonly" :class="fontClasses">

                <text-editor v-if="editMode"
                             v-model="thankYouTextModel"
                             hint="Thank you text"
                >
                            <span>
                                {{thankYouTextModel}}
                            </span>
                </text-editor>

                <div v-if="!editMode">
                    {{thankYouText}}
                </div>

            </div>

            <!-- RATE THIS SURVEY TEXT -->
            <div v-else :class="fontClasses">

                <text-editor v-if="editMode"
                             v-model="questionTextModel"
                             hint="Question text"
                >
                            <span>
                                {{questionTextModel}}
                            </span>
                </text-editor>

                <div v-if="!editMode">
                    {{questionText}}
                </div>

            </div>

            <v-rating
                    v-model="ratingModel"
                    color="yellow darken-3"
                    :background-color="isDarkColor(color) ? 'grey lighten-1' : 'grey darken-1'"
                    empty-icon="$vuetify.icons.ratingFull"
                    half-increments
                    hover
                    x-large
                    :readonly="!editMode && readonly"
            ></v-rating>

        </v-card-text>
    </v-card>
</template>

<script>

    import TextEditor from "../TextEditor";
    import colorMixin from "../DynamicProflingQuestions/colorMixin";

    export default {

        mixins: [colorMixin],

        components: {
            TextEditor
        },

        props: {
            editMode: {
                type: Boolean,
                required: false,
                default: false,
            },
            value: {
                type: Number | null,
                required: false,
            },
            questionText: {
                type: String | null,
                required: true,
            },
            thankYouText: {
                type: String | null,
                required: true,
            },
            color: {
                type: String | null,
                required: true,
                default: '#EEEEEE',
            }
        },

        data() {
            return {
                data: {
                    rating_thank_you_text: null,
                    rating_question_text: null,
                },
                readonly: false,
            }
        },

        watch: {
            thankYouText(value) {
                this.data.rating_thank_you_text = value;
            },
            questionText(value) {
                this.data.rating_question_text = value;
            }
        },

        mounted() {
            this.data.rating_thank_you_text = this.thankYouText;
            this.data.rating_question_text = this.questionText;
        },

        computed: {
            questionTextModel: {
                get() {
                    return this.data.rating_question_text;
                },
                set(value) {
                    this.data.rating_question_text = value;
                    this.emitObject();
                }
            },

            thankYouTextModel: {
                get() {
                    return this.data.rating_thank_you_text;
                },
                set(value) {
                    this.data.rating_thank_you_text = value;
                    this.emitObject();
                }
            },

            fontClasses() {
                let classes = ['subtitle-1', 'grey--text'];

                if (this.isDarkColor(this.color)) {
                    classes.push('text--lighten-3');
                } else {
                    classes.push('text--darken-3');
                }

                if (this.editMode) classes.push('cursor-pointer');

                return classes;
            },

            ratingModel: {
                get() {
                    if (this.value !== null) {
                        this.readonly = true;
                    }
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                    this.readonly = true;
                }
            }
        },

        methods: {
            emitObject() {
                this.$emit('change:subPanelTranslations', this.data);
            }
        }
    }
</script>
